import type {z} from "zod";

import {ContactInputFields, PhoneNumberInput} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const contactInputFields = ContactInputFields.shape;

export const addRepresentativeContactNameSchema = requiredStringSchema(
  contactInputFields.name,
  contactFieldLabelIds.name,
);
export const addRepresentativeContactEmailSchema = contactInputFields.email.or(zod.literal(""));

const addRepresentativeContactFormFieldsSchema = zod.object({
  name: addRepresentativeContactNameSchema,
  description: contactInputFields.description,
  email: addRepresentativeContactEmailSchema,
  phone: PhoneNumberInput.shape.nationalNumber.optional(),
  phonePrefix: PhoneNumberInput.shape.regionCode.optional(),
});

export const addRepresentativeContactFormSchema =
  addRepresentativeContactFormFieldsSchema.superRefine((value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }

    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({
        code: "custom",
        message: "Phone prefix is required",
        path: ["phonePrefix"],
      });
    }
  });
export type AddRepresentativeContactFormPayload = z.output<
  typeof addRepresentativeContactFormSchema
>;

export const draftAddRepresentativeContactFormSchema =
  addRepresentativeContactFormFieldsSchema.partial();
export type DraftAddRepresentativeContactFormPayload = z.output<
  typeof draftAddRepresentativeContactFormSchema
>;
